import { render, staticRenderFns } from "./relatorioAEE.vue?vue&type=template&id=d84742b2"
import script from "./relatorioAEE.vue?vue&type=script&lang=js"
export * from "./relatorioAEE.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports